import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Actions} from '../../../common/actions';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Card, Button, Icon, Popup, Header,
  Modal, Container, Table, Divider} from 'semantic-ui-react';
import './vehiclesValidation.scss';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import moment from 'moment';
import {renderTableLoader} from '../../../common/components/tableLoader';
import VehiclesTable from './vehiclesTable';
import {getColumns, renderCheckIcon, renderCrossIcon} from './vehiclesTableColumns';


const {
  fetchVehiclesValidationList,
  sendVehiclesValidationNotifation,
  sendVehiclesAccesoriesTransfer,
  navigateTo,
} = Actions;

const VehiclesValidation = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const {loading, data} = useSelector((state) => state.vehiclesValidation);
  const {anticipatedInvoiceVehicles, requiredAccessoriesStock, requiredDevicesStock} = data;
  const [vehiclesValidation, setVehiclesValidation] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.AnticipatedInvoiceVehicleValidation, scopes.See) &&
      !hasAccessPermission(permissions, resources.AnticipatedInvoiceVehicleValidation, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(fetchVehiclesValidationList());
  }, []);

  useEffect(() => {
    if (anticipatedInvoiceVehicles) {
      setVehiclesValidation(anticipatedInvoiceVehicles.map((x, i) => {
        /* if (i === anticipatedInvoiceVehicles.length - 1) {
          return {
            ...x,
            'hunter': x.hunter ? 'SI' : 'NO',
            'dateMod': moment(x.dateMod).format(reverseShortDate),
            'checked': false,
            'accessoriesValidated': false,
          };
        } */
        return {
          ...x,
          'hunter': x.hunter ? 'SI' : 'NO',
          'dateMod': moment(x.dateMod).format(reverseShortDate),
          'checked': false,
        };
      }));
    }
  }, [anticipatedInvoiceVehicles]);

  const handleChangeCheck = (selected) => {
    const vehiclesSelected = vehiclesValidation.map(
      (item) => {
        if (item.chassis === selected.chassis) {
          return {...item, 'checked': !selected.checked};
        }
        return item;
      }
    );
    setVehiclesValidation(vehiclesSelected);
  };


  const checkAllAnticipatedInvoicesVehicle = (checkValue, filteredRows) => {
    const dataFiltered = filteredRows;
    const allVehicles =
      vehiclesValidation.map((veh) => {
        const itemFiltered = dataFiltered.findIndex((x) => x.original.chassis === veh.chassis);
        if (itemFiltered === -1 || veh.checked === checkValue) {
          return {...veh};
        }
        return {...veh, 'checked': !veh.checked};
      });
    setVehiclesValidation(allVehicles);
  };

  const handleFilterCheckAll = (input, filteredRows) => {
    checkAllAnticipatedInvoicesVehicle(input.checked, filteredRows);
  };

  const getAllCheckFilterValue = (filteredRows) => {
    return filteredRows.every(({original}) => original.checked === true);
  };

  const disableCheckAllFilter = (filteredRows) => {
    return filteredRows && filteredRows.length > 0 ? false : true;
  };

  const renderAccesoriesCombo = (combo, comboDetail) => {
    return !combo ?
      '' :
      <Popup trigger={<div style={{'cursor': 'pointer'}} >{combo}</div>} flowing>
        <Table>
          <Table.Header>
            <Table.Cell>Accesorio</Table.Cell>
            <Table.Cell>Cantidad</Table.Cell>
            <Table.Cell>Stock</Table.Cell>
          </Table.Header>
          <Table.Body>
            {comboDetail.map((acc, i) => {
              return <Table.Row key={`${combo}-${acc.accessoryCode}-${i}`}>
                <Table.Cell>{acc.accessoryName}</Table.Cell>
                <Table.Cell>{acc.accessoryQty}</Table.Cell>
                <Table.Cell>
                  {acc.hasStock ? renderCheckIcon() : renderCrossIcon()}</Table.Cell>
              </Table.Row>;
            })}
          </Table.Body>
        </Table>
      </Popup>;
  };

  const getCheckedVehicles = () => {
    return vehiclesValidation.filter((x) => x.checked);
  };

  const checkReservation = (vehicle) => {
    if (vehicle.hunter === 'SI' && vehicle.hasAccessories) {
      return vehicle.transfer && vehicle.device_reserved === 'S';
    }
    if (vehicle.hunter === 'NO' && vehicle.hasAccessories) {
      return vehicle.transfer;
    }
    if (vehicle.hunter === 'SI' && !vehicle.hasAccessories) {
      return vehicle.device_reserved === 'S';
    }
    if (vehicle.hunter === 'NO' && !vehicle.hasAccessories) {
      return true;
    }
    return false;
  };

  const columns = getColumns({'renderAccesoriesCombo': renderAccesoriesCombo, 'checkReservation': checkReservation});

  const sendNotification = () => {
    const data = {
      'requiredAccessoriesStock': requiredAccessoriesStock,
      'requiredDevicesStock': requiredDevicesStock,
    };
    dispatch(sendVehiclesValidationNotifation(data));
  };

  const sendTransfer = (reverse) => {
    const vehiclesChecked = getCheckedVehicles();
    const data = {
      'anticipatedInvoicesVehicles': vehiclesChecked,
      'reverse': reverse || false,
    };
    dispatch(sendVehiclesAccesoriesTransfer(data));
  };

  const reverseTransfer = () => {
    sendTransfer(true);
  };

  const renderNotificationButton = () => {
    const noAccessories = requiredAccessoriesStock && requiredAccessoriesStock.length > 0 ? false : true;
    const noDevices = requiredDevicesStock && requiredDevicesStock.length > 0 ? false : true;
    if (!hasAccessPermission(permissions, resources.AnticipatedInvoiceVehicleValidation, scopes.Edit)) {
      return null;
    }
    if (noAccessories && noDevices) {
      return null;
    }
    return (
      <Button primary className='toyota-primary flex' disabled={loading}><Icon name='send' />Notificar</Button>
    );
  };

  const renderNotificationModal = () => {
    return (
      <Modal
        trigger={renderNotificationButton()}
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {'key': 'done', 'content': 'Enviar notificación', 'positive': true,
            'onClick': () => sendNotification(false),
            'primary': true,
          },
        ]}
        header={<Header><Icon name='send' />Notificar stock insuficiente</Header>}
        content={
          <Container style={{'paddingLeft': '2.25em', 'paddingRight': '2.25em'}}>
            {requiredAccessoriesStock ?
              <React.Fragment>
                <h4 style={{'margin': '0'}}>Accesorios</h4>
                <Table style={{'marginTop': '0'}}>
                  <Table.Header>
                    <Table.Row>
                      <Table.Cell>Código</Table.Cell>
                      <Table.Cell>Descripción</Table.Cell>
                      <Table.Cell>Cantidad</Table.Cell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {requiredAccessoriesStock.map((acc, i) => {
                      return (
                        <Table.Row key={`${acc.code}_${i}`} className='loader'>
                          <Table.Cell colSpan='100%'>{acc.code}</Table.Cell>
                          <Table.Cell colSpan='100%'>{acc.name}</Table.Cell>
                          <Table.Cell colSpan='100%'>{acc.quantity}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
              </React.Fragment> :
              ''}
            {requiredDevicesStock ?
              <React.Fragment>
                <Divider />
                <h4 style={{'margin': '0'}}>Dispositivos</h4>
                <Table style={{'marginTop': '0'}}>
                  <Table.Header>
                    <Table.Row>
                      <Table.Cell>Código</Table.Cell>
                      <Table.Cell>Descripción</Table.Cell>
                      <Table.Cell>Cantidad</Table.Cell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {requiredDevicesStock.map((acc) => {
                      return (
                        <Table.Row className='loader'>
                          <Table.Cell colSpan='100%'>{acc.code}</Table.Cell>
                          <Table.Cell colSpan='100%'>{acc.name}</Table.Cell>
                          <Table.Cell colSpan='100%'>{acc.quantity}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
              </React.Fragment> :
              ''}
          </Container>
        }
      />
    );
  };

  const renderTransfersModal = () => {
    return (
      <Modal
        trigger={
          <Button primary className='toyota-primary flex'
            loading={loading} disabled={loading}
            icon={<Icon name='save' className='save'
              style={{'display': 'content'}} />} content='Reservar Accesorios'></Button>
        }
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {'key': 'done', 'content': 'Confirmar transferencia', 'positive': true,
            'onClick': () => sendTransfer(),
            'primary': true,
          },
        ]}
        header={<Header><Icon name='send' />Transferencia de Accesorios</Header>}
        content={
          <h3 style={{'textAlign': 'center'}}>¿Confirma la transferencia de accesorios para los <strong>{
            getCheckedVehicles()?.length || '0'
          }</strong> vehículos seleccionados?</h3>
        }
      />
    );
  };

  return (
    <div className='set-sales-list'>
      <Card raised fluid>
        <div className='title-bar'>
          <div className='title'>
            <h2>Facturación Anticipada - Validación de vehículos</h2>
            <div className='title-bar-actions'>
              {
                getCheckedVehicles()?.length > 0 &&
                  getCheckedVehicles()?.every((x) => checkReservation(x) &&
                  ((x.hasAccessories && x.transferStatus === 'C') ||
                  (x.hunter === 'SI' && x.device_reserved === 'S'))) &&
                <Button primary className='toyota-primary flex'
                  loading={loading} disabled={loading}
                  icon={<Icon name='cancel' style={{'display': 'content'}} />}
                  onClick={reverseTransfer} content='Anular Reservas' />
              }
              {
                getCheckedVehicles()?.length > 0 && getCheckedVehicles()?.every((x) => !checkReservation(x)) &&
                renderTransfersModal()}
              {renderNotificationModal()}
            </div>
          </div>
        </div>
      </Card>
      <Card raised fluid>
        {loading ?
          renderTableLoader() :
          <VehiclesTable tableColumns={columns} tableData={vehiclesValidation}
            selection={{
              'handleChangeCheck': handleChangeCheck.bind(this),
              'disableCheckAllFilter': disableCheckAllFilter.bind(this),
              'handleFilterCheckAll': handleFilterCheckAll.bind(this),
              'allCheckFilterValue': getAllCheckFilterValue.bind(this),
            }} />
        }
      </Card>
    </div>
  );
};

export default VehiclesValidation;
